<template>
  <div class="header-father">
    <div v-if="menu_show">
      <i class="el-icon-menu scrollow-menu" @click="showDraw"></i>
    </div>
    <div
      class="header-father"
      style="width: auto;padding:0 20px; justify-content:left;"
    >
      <!-- @click="goHome" -->
      <div>
        <img
          class="el-header-img"
          src="@/assets/pic/yvzhou.png"
          :style="header_style"
          alt=""
        />
      </div>
      <!-- :style="width:" -->
      <b class="header-b">1.0.5 版本</b>
    </div>
    <div class="right">
      <div class="right" style="">
        <!-- 非options -->
        <div class="right">
          <!-- 刷新 -->
          <el-popover
            placement="bottom"
            trigger="hover"
            content="刷新页面会清除页面缓存"
            :visible-arrow="false"
            :close-delay="0"
          >
            <div @click="headerreload" class="right-item" slot="reference">
              <i
                class="right-item-i el-icon-refresh"
                style="font-weight:900"
              ></i>
              <span>刷新页面</span>
            </div>
          </el-popover>
          <!-- 电话联系 -->
          <el-popover
            v-if="false"
            placement="bottom-start"
            width="200"
            trigger="hover"
            :visible-arrow="false"
            :close-delay="0"
          >
            <div class="right-popover">
              <div style="font-size:17px;">有问题请联系</div>
              <div style="height:10px"></div>
              <div style="color:#000 !important;">
                17----------x
              </div>

              周一至周六 8:30 - 17:30
            </div>

            <div class="right-item" slot="reference">
              <i class="el-icon-phone right-item-i"></i>
              <span>服务电话</span>
            </div>
          </el-popover>

          <!-- 微信 -->
          <el-popover
            v-if="false"
            placement="bottom"
            width="200"
            trigger="hover"
            content="周一至周六 8:30 - 17:30"
            :visible-arrow="false"
            :close-delay="0"
          >
            <div class="right-item" slot="reference">
              <i class="right-item-i iconfont icon-weixin"></i>
              <span>微信客服</span>
            </div>
          </el-popover>
          <!-- 意见反馈 -->
          <div v-if="false" class="right-item">
            <i class="right-item-i el-icon-s-comment"></i>
            <span>意见反馈</span>
          </div>
        </div>
        <el-dropdown @command="handleCommand">
          <div>
            <div
              class="right-item-head"
              style="align-items:center;"
              slot="reference"
            >
              <img
                src="../assets/pic/yvzhou.png"
                style="height:30px;margin-right:10px;border-radius: 15px;"
                alt=""
              />
              <div class="right-item-head-name">
                {{ account_name }}
              </div>
            </div>
          </div>

          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="info" style="width:180px"
              >店铺信息</el-dropdown-item
            > -->
            <el-dropdown-item command="logout" style="width:180px">
              <i class="el-icon-switch-button" style="font-weight:700"></i>
              退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { serviceProviderQuery } from "@/api/service.js";
import { getMerchantInfo } from "@/api/merchant.js";
export default {
  props: ["btnsize"],
  inject: ["reload"],
  data() {
    return {
      account_name: "",
      btn_size: "",
      menu_show: false,
      header_style: "height:80px;"
    };
  },
  computed: {
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        //TODO: 以后加上联系xx时记得加上
        if (newinner.innerWidth < 1200) {
          this.menu_show = true;
        } else {
          this.menu_show = false;
        }
        // this.menu_show = false;

        if (newinner.innerHeight < 740) {
          this.header_style = "height:60px;";
        } else {
          this.header_style = "height:80px;";
        }
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    // console.log("header",this.availWH);
    //获取显示的名称（当用店铺的账号或者是服务商的账号登录时）
    if (localStorage.getItem("token_type") == "service") {
      const res = await serviceProviderQuery();
      if (this.testR(res)) {
        localStorage.setItem("service_name", res.data.resp_data.service_name);
      }
      //TODO: 店铺保存店铺名称
    }
    if (localStorage.getItem("token_type") == "merchant") {
      const res = await getMerchantInfo();
      if (this.testR(res)) {
        localStorage.setItem("merchant_name", res.data.resp_data.sub_name);
      }
    }
    this.getLocalName();
    this.btn_size = this.btnsize;
  },
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS", "CLEARTABS"]),
    showDraw() {
      this.$emit("showDraw", true);
    },
    headerreload() {
      this.reload();
    },
    lohout() {
      /* TODO: */
      if (
        localStorage.getItem("token_type") == "merchant" ||
        localStorage.getItem("login_type") == "merchant"
      ) {
        var info = {
          merchant_id: localStorage.getItem("merchant_id"),
          pass_word: localStorage.getItem("pass_word")
        };
        // console.log("里面",info)
        this.UPDATEMENUTABS("/login");
        this.$router.push("/login");
      } else {
        var info = {
          service_no: localStorage.getItem("service_no"),
          pass_word: localStorage.getItem("pass_word")
        };
        this.UPDATEMENUTABS("/servicerlogin");
        this.$router.push("/servicerlogin");
      }

      this.CLEARTABS();
      localStorage.clear();
      // this.$router.push("login");
      console.log("外面", info);
      if (info.merchant_id && localStorage.getItem("login_type") != "account") {
        localStorage.setItem("merchant_id", info.merchant_id);
        localStorage.setItem("pass_word", info.pass_word);
      } else if (
        info.service_id &&
        localStorage.getItem("login_type") != "account"
      ) {
        localStorage.setItem("service_no", info.service_no);
        localStorage.setItem("pass_word", info.pass_word);
      }
    },
    flushPage() {
      this.reload();
    },
    handleCommand(command) {
      console.log(command);
      switch (command) {
        case "info":
          break;
        case "logout":
          this.lohout();
          break;
      }
    },
    async getLocalName() {
      //服务商
      if (
        localStorage.getItem("token_type") == "service" ||
        (localStorage.getItem("token_type") == "account" &&
          localStorage.getItem("login_type") == "service")
      ) {
        this.account_name = localStorage.getItem("service_name")
          ? localStorage.getItem("service_name")
          : localStorage.getItem("merchant_name");
        // console.log("获取服务商名称",localStorage.getItem("service_name"))
      }
      //店铺
      if (
        localStorage.getItem("token_type") == "merchant" ||
        (localStorage.getItem("token_type") == "account" &&
          localStorage.getItem("login_type") == "merchant")
      ) {
        this.account_name = localStorage.getItem("merchant_name")
          ? localStorage.getItem("merchant_name")
          : localStorage.getItem("merchant_id");
      }
    }
  }
};
</script>
<style scoped lang="less">
.header-father {
  width: 100%;
  // height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  .scrollow-menu {
    cursor: pointer;
    &:hover {
      color: @primary-color;
    }
  }
  // padding: 10px 0;
  .el-header-img {
    height: 20px;
    cursor: pointer;
    height: 100%;
    margin: 10px 15px 0 0;
    // border-radius: 25px;
  }
  .el-header-icon {
    cursor: pointer;
    height: 30px;
    margin: 5px 15px 0 0;
    // border-radius: 25px;
  }
  .right {
    width: auto;
    font-size: 16px;
    display: flex;

    // margin-right: 80px;
    .right-popover {
      font-size: 16px !important;
      color: #c0c4cc;
      .popover-item {
        display: block;
        height: 40px !important;
        width: 100px;
        background-color: rgb(239, 96, 96) !important;
      }
    }
    .right-item-head {
      display: flex;
      align-items: center;
      height: 40px;
      width: auto;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
      padding: 0 20px;
      .right-item-head-name {
        width: 100px;
        .wty-ellipsis();
      }
    }
    .right-item-head:hover {
      background-color: @bg-show;
    }
    .right-item {
      width: 140px;
      height: 40px;
      text-align: center;
      line-height: 2.5;
      border-radius: 5px;
      cursor: pointer;
    }
    .right-item-i {
      margin-right: 10px;
    }
    .right-item:hover {
      background-color: @bg-show;
    }
  }
}
</style>
